import React from "react";
import { connect } from "react-redux";
import Request from "../../request";
import { Card, Col, Row } from "antd";
import {
    FaCheckCircle, FaFileInvoiceDollar, FaFileInvoice, FaRegFileAlt, FaExclamationTriangle, FaUserClock,
    FaHistory, FaUniversity, FaBookOpen, FaHandshake, FaFileExport, FaGraduationCap
} from 'react-icons/fa';
import ListDrawer from './list';
import NotAddedUniversityCommissionDrawer from "../../components/drawers/notAddedUniversityCommissionDrawer";
import PendingCourseCommissionDrawer from "../../components/drawers/pendingCourseCommissionDrawer";
import GeneratedInvoiceDetailsDrawer from "../../components/drawers/generatedInvoiceDetailsDrawer";
import { RightsWrapper } from "../../components/_utils/utils";
import UniversityCommApprovalDrawer from "../../components/drawers/universityCommApprovalDrawer";
import UniversityCourseCommApprovalDrawer from "../../components/drawers/universityCourseCommApprovalDrawer";

class ClaimAccountDashboard extends React.Component {
    state = {
        drawer: false,
        drawerParam: {},
        uniCommDrawer: false,
        uniCommParam: {},
        courseCommDrawer: false,
        courseCommParam: {},
        generatedInvoiceDrawer: false,
        generatedInvoiceParam: {},
        uniCommApprovalDrawer: false,
        uniCourseCommApprovalDrawer: false,
        uniAppCommParam: {},
        uniAppCourseCommParam: {},
        visaApprovedToday: { total: 0, "arr": [] },
        invoiceToBeGeneratedToday: { total: 0, "arr": [] },
        invoiceGeneratedToday: { total: 0, 'arr': [] },
        invoiceSubmittedToUni: { total: 0, 'arr': [] },
        missedInvoiceGeneration: { total: 0, 'arr': [] },
        pendingStudentWithdrawalReview: { total: 0, 'arr': [] },
        reverifyWithdrawals: { total: 0, 'arr': [] },
        commNotAddedUniversities: { total: 0, 'arr': [] },
        notAddedCourseCommission: { total: 0, 'arr': [] },
        pendingUniversityCommCount: 0,
        pendingCourseCommCount: 0,
    }


    loadApi = async () => {
        Request.getClaimAccountDashboardData().then(({ visaApprovedToday, invoiceToBeGeneratedToday, invoiceGeneratedToday, missedInvoiceGeneration, pendingStudentWithdrawalReview, reverifyWithdrawals, commNotAddedUniversities, notAddedCourseCommission, pendingUniversityCommCount, invoiceSubmittedToUni, pendingCourseCommCount }) => {
            this.setState({
                visaApprovedToday,
                invoiceToBeGeneratedToday,
                invoiceGeneratedToday,
                missedInvoiceGeneration,
                pendingStudentWithdrawalReview,
                reverifyWithdrawals,
                commNotAddedUniversities,
                notAddedCourseCommission,
                pendingUniversityCommCount,
                pendingCourseCommCount,
                invoiceSubmittedToUni
            })
        })
    }

    componentDidMount() {
        this.loadApi();
    }

    render() {
        let { visaApprovedToday,
            invoiceToBeGeneratedToday,
            invoiceGeneratedToday,
            invoiceSubmittedToUni,
            missedInvoiceGeneration,
            pendingStudentWithdrawalReview,
            reverifyWithdrawals,
            commNotAddedUniversities,
            notAddedCourseCommission,
            drawer,
            drawerParam,
            uniCommDrawer,
            uniCommParam,
            courseCommDrawer,
            courseCommParam,
            generatedInvoiceDrawer,
            generatedInvoiceParam,
            pendingUniversityCommCount,
            pendingCourseCommCount,
            uniCommApprovalDrawer,
            uniCourseCommApprovalDrawer,
            uniAppCommParam,
            uniAppCourseCommParam
        } = this.state;
        return (
            <div className="fod-container">
                {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                {uniCommDrawer && <NotAddedUniversityCommissionDrawer param={uniCommParam} onClose={() => this.setState({ uniCommDrawer: false })} />}
                {courseCommDrawer && <PendingCourseCommissionDrawer param={courseCommParam} onClose={() => this.setState({ courseCommDrawer: false })} />}
                {generatedInvoiceDrawer && <GeneratedInvoiceDetailsDrawer param={generatedInvoiceParam} onClose={() => this.setState({ generatedInvoiceDrawer: false })} />}
                {uniCommApprovalDrawer && <UniversityCommApprovalDrawer param={uniAppCommParam} onClose={() => this.setState({ uniCommApprovalDrawer: false })} />}
                {uniCourseCommApprovalDrawer && <UniversityCourseCommApprovalDrawer param={uniAppCourseCommParam} onClose={() => this.setState({ uniCourseCommApprovalDrawer: false })} />}
                <h4 className="fod-heading">Finance Account</h4>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-green">
                                <FaCheckCircle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Visa Approved Today</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Visa Approved Today", arr: visaApprovedToday.arr, count: visaApprovedToday.total, bgColorClass: "bg-green", icon: <FaCheckCircle /> } })}>{visaApprovedToday.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-blue">
                                <FaFileInvoiceDollar />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Invoices To Be Generated Today</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Invoices To Be Generated Today", arr: invoiceToBeGeneratedToday.arr, count: invoiceToBeGeneratedToday.total, bgColorClass: "bg-blue", icon: <FaFileInvoiceDollar /> } })}>{invoiceToBeGeneratedToday.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-cyan">
                                <FaRegFileAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Invoices Generated Today</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ generatedInvoiceDrawer: true, generatedInvoiceParam: { title: "Invoices Generated Today", arr: invoiceGeneratedToday.arr, count: invoiceGeneratedToday.total, bgColorClass: "bg-cyan", icon: <FaRegFileAlt /> } })}>{invoiceGeneratedToday.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red">
                                <FaExclamationTriangle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Missed Invoice Generation</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Missed Invoice Generation", arr: missedInvoiceGeneration.arr, count: missedInvoiceGeneration.total, bgColorClass: "bg-red", icon: <FaExclamationTriangle /> } })}>{missedInvoiceGeneration.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            {/* Changed background to bg-green and icon to FaFileExport */}
                            <div className="stat-icon-wrapper bg-green">
                                <FaFileExport />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Invoices Submitted</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({
                                        generatedInvoiceDrawer: true,
                                        generatedInvoiceParam: {
                                            title: "Invoices Submitted",
                                            arr: invoiceSubmittedToUni.arr,
                                            count: invoiceSubmittedToUni.total,
                                            bgColorClass: "bg-green", // Sync color
                                            icon: <FaFileExport />    // Sync icon
                                        }
                                    })}>
                                        {invoiceSubmittedToUni.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-amber">
                                <FaUserClock />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Pending Student Withdrawal Review</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Pending Student Withdrawal Review", arr: pendingStudentWithdrawalReview.arr, count: pendingStudentWithdrawalReview.total, bgColorClass: "bg-amber", icon: <FaUserClock /> } })}>{pendingStudentWithdrawalReview.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-orange">
                                <FaHistory />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Reverify Withdrawals</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Reverify Withdrawals", arr: reverifyWithdrawals.arr, count: reverifyWithdrawals.total, bgColorClass: "bg-orange", icon: <FaHistory /> } })}>{reverifyWithdrawals.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-teal">
                                <FaUniversity />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Missing University Commissions</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ uniCommDrawer: true, uniCommParam: { title: "Missing University Commissions", arr: commNotAddedUniversities.arr, count: commNotAddedUniversities.total, bgColorClass: "bg-teal", icon: <FaUniversity /> } })}>{commNotAddedUniversities.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-purple">
                                <FaBookOpen />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Pending Course Commissions</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ courseCommDrawer: true, courseCommParam: { title: "Pending Course Commissions", arr: notAddedCourseCommission.arr, count: notAddedCourseCommission.total, bgColorClass: "bg-purple", icon: <FaBookOpen /> } })}>{notAddedCourseCommission.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <RightsWrapper myRight={"approvePendingAgreement.view"}>
                        <Col span={6}>
                            <div className="stat-card">
                                {/* Changed to Teal for a fresh 'Agreement' feel */}
                                <div className="stat-icon-wrapper bg-teal">
                                    <FaHandshake />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Pending Commission Approval</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            uniCommApprovalDrawer: true,
                                            uniAppCommParam: {
                                                title: 'Pending Commission Approval',
                                                bgColorClass: "bg-teal",
                                                icon: <FaHandshake />
                                            }
                                        })}>
                                            {pendingUniversityCommCount}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                {/* Changed color theme to Premium Purple/Indigo and icon to Graduation Cap for 'Course' differentiation */}
                                <div className="stat-icon-wrapper bg-purple" style={{ background: '#722ed1', color: '#fff' }}>
                                    <FaGraduationCap style={{ fontSize: '20px' }} />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Pending Course Commission Approval</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            uniCourseCommApprovalDrawer: true,
                                            uniAppCourseCommParam: {
                                                title: 'Pending Course Commission Approval',
                                                bgColorClass: "bg-purple",
                                                icon: <FaGraduationCap />
                                            }
                                        })}>
                                            {pendingCourseCommCount}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </RightsWrapper>
                </Row>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
    (ClaimAccountDashboard)